import React,{ useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import WalletForm from '../../components/forms/WalletForm/WalletForm';

const WalletView = () => {

  const { uid } = useParams();

  return (
    <AuthLayout pageName="wallet">
      <WalletForm userId={uid} />
    </AuthLayout>
  );
};

export default WalletView;
